export default __webpack_public_path__ + "static/product-engineering-services-peerbits-f3b9f003f1d7e38bf3eb0ae06959b6c1.png";